export const APP_DIMENSION_NAME = {
  platform: 'platform',
  deviceName: 'device_name',
};

export const VIDEO_DIMENSION_NAME = {
  deviceName: 'm3.dv.n',
  assetName: 'OBJECT_NAME',
};

export const TOOLTIP_FOR_HIDDEN =
  'Hide this filter from regular users. Show only to special Conviva users';

export const READ_ONLY_MESSAGE = 'Read-only users cannot save filters';

export const DISABLED_TOOLTIP_MESSAGE = `The saved filter isn't supported on current page`;

export const NOT_OPERATOR_DISABLED_TOOLTIP_MESSAGE = `Not equals and not contains doesn't support multiple values in a Group`;

export const OPERATOR_SEPARATE_TOOLTIP_MESSAGE = `Multiple values will be split into separate "not equals" or "not contains" filter rules`;

export const DEFAULT_RULE_OPERATOR = 'eq';
